(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/bingo-react/assets/javascripts/router.js');
'use strict';

const {
  BrowserRouter: Router,
  Route,
  Switch
} = ReactRouterDOM;
const {
  productIds
} = svs.components.lbUtils.sportProducts;
const {
  withMetaTags
} = svs.components.lbUtils.withMetaTags;
const {
  pages: {
    BingoLobby,
    BingoArticles,
    BingoSchool,
    BingoChatSchedule,
    WidgetPage
  },
  components: {
    nav_menu: {
      BingoNavMenu
    }
  }
} = svs.bingo_react;
const {
  MenuTabTypes
} = svs.bingo_react.components.common.constants;
const getPageComponent = tabType => {
  switch (tabType) {
    case MenuTabTypes.BingoLobby:
      return BingoLobby;
    case MenuTabTypes.BingoArticles:
      return BingoArticles;
    case MenuTabTypes.BingoSchool:
      return BingoSchool;
    case MenuTabTypes.BingoChatSchedule:
      return BingoChatSchedule;
    default:
      return WidgetPage;
  }
};
const BingoRouter = () => {
  const routes = svs.bingo_react.data.tabsConfig;
  const activeRoutes = routes.filter(route => route.active);
  const lobbyRoute = routes.find(route => route.path === '' && route.tabType === 'lobby');
  return React.createElement(Router, {
    basename: svs.core.data.baseUrl
  }, React.createElement(BingoNavMenu, {
    routes: activeRoutes
  }), React.createElement(Switch, null, React.createElement(Route, {
    exact: true,
    path: "/",
    render: () => {
      const EnhancedComponent = withMetaTags({
        Component: BingoLobby,
        route: lobbyRoute,
        productId: productIds.BINGO_CLASSIC,
        setDocTitle: true,
        setMetaDesc: true
      });
      return React.createElement(EnhancedComponent, {
        headerConfig: lobbyRoute.headerConfig,
        widgetAreaIndex: lobbyRoute.widgetArea
      });
    }
  }), activeRoutes.map(route => React.createElement(Route, {
    exact: route.path === '',
    key: route.path,
    path: "/".concat(route.path),
    render: () => {
      const Component = getPageComponent(route.tabType);
      const EnhancedComponent = withMetaTags({
        Component,
        route,
        productId: productIds.BINGO_CLASSIC,
        setDocTitle: true,
        setMetaDesc: true
      });
      return React.createElement(EnhancedComponent, {
        headerConfig: route.headerConfig,
        widgetAreaIndex: route.widgetArea
      });
    }
  }))));
};
setGlobal('svs.bingo_react.BingoRouter', BingoRouter);

 })(window);